import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import getServiceNameFromUrl from '../../lib/getServiceNameFromUrl';

import BrandIcon from '../icons/BrandIcon';
import Blocked from './Blocked';
import Image, { ImageProps } from './Image';
import Sponsor from './Sponsor';

import styles from '../../styles/partials/collection-image.module.css';

export interface CollectionImageProps extends ImageProps {
    title?: string | null;
    media?: Image | null; // Remplacer any par le type Image si disponible
    brand?: BrandHandle | null;
    broadcast?: Broadcast | null;
    blocked?: boolean;
    unblocked?: boolean;
    withBrandIcon?: boolean;
    withoutBlockedIcon?: boolean;
    withBroadcast?: boolean;
    className?: string | null;
    iconClassName?: string | null;
    brandIconClassName?: string | null;
    blockedIconClassName?: string | null;
}

function CollectionImage({
    title = null,
    media = null,
    brand = null,
    broadcast = null,
    blocked = false,
    unblocked = false,
    withBrandIcon = false,
    withoutBlockedIcon = false,
    withBroadcast = false,
    className = null,
    iconClassName = null,
    brandIconClassName = null,
    blockedIconClassName = null,
    ...props
}: CollectionImageProps) {
    const { organisation = null, url: broadcastUrl = null } = broadcast || {};
    const finalOrganisation =
        organisation === null && broadcastUrl !== null
            ? { name: getServiceNameFromUrl(broadcastUrl) }
            : organisation;
    const { name = null } = finalOrganisation || {};
    if (media === null) {
        return (
            <div
                className={classNames([
                    styles.container,
                    styles.empty,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                {title}
            </div>
        );
    }
    return (
        <Image
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            loading="lazy"
            media={media}
            {...props}
        >
            {blocked && !withoutBlockedIcon ? (
                <Blocked
                    short
                    unblocked={unblocked}
                    className={classNames([styles.blockedIcon, blockedIconClassName])}
                />
            ) : null}
            {withBrandIcon && brand !== null ? (
                <BrandIcon
                    type={brand}
                    className={classNames([
                        styles.icon,
                        styles.brandIcon,
                        {
                            [iconClassName]: iconClassName !== null,
                            [brandIconClassName]: brandIconClassName !== null,
                        },
                    ])}
                />
            ) : null}
            {withBroadcast && finalOrganisation !== null ? (
                <div
                    className={classNames([
                        styles.broadcast,
                        styles[camelCase(name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))],
                    ])}
                >
                    <Sponsor
                        organisation={finalOrganisation}
                        withoutPresentedBy
                        withImage
                        className={classNames([styles.organisation])}
                        imageClassName={styles.image}
                    />
                </div>
            ) : null}
        </Image>
    );
}

export default CollectionImage;
